import { ANALYTICS_CONFIG, isDebugEnabled, getDebugLogPrefix } from './config.js';

// Logger centralizzato per analytics
export const logger = {
  log: (message, data = null) => {
    if (isDebugEnabled()) {
      console.log(`${getDebugLogPrefix()} ${message}`, data || '');
    }
  },
  
  error: (message, error = null) => {
    if (isDebugEnabled()) {
      console.error(`${getDebugLogPrefix()} ERROR: ${message}`, error || '');
    }
  },
  
  warn: (message, data = null) => {
    if (isDebugEnabled()) {
      console.warn(`${getDebugLogPrefix()} WARNING: ${message}`, data || '');
    }
  }
};

// Validazione parametri
export const validateAnalyticsParams = (params = {}) => {
  const errors = [];
  
  if (typeof params !== 'object') {
    errors.push('Parameters must be an object');
  }
  
  // Validazione valori specifici
  if (params.value && typeof params.value !== 'number') {
    errors.push('Value must be a number');
  }
  
  if (params.currency && typeof params.currency !== 'string') {
    errors.push('Currency must be a string');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Normalizzazione dati prodotto per GA4
export const normalizeProductData = (product) => {
  if (!product || typeof product !== 'object') {
    logger.warn('Invalid product data provided');
    return null;
  }
  
  return {
    item_id: product.id?.toString() || '',
    item_name: product.name || product.title || '',
    item_category: product.category || product.categoryName || '',
    price: parseFloat(product.price) || 0,
    seller_id: product.sellerId?.toString() || product.seller?.id?.toString() || '',
    currency: ANALYTICS_CONFIG.PARAMETERS.CURRENCY
  };
};

// Normalizzazione dati categoria
export const normalizeCategoryData = (category) => {
  if (!category || typeof category !== 'object') {
    logger.warn('Invalid category data provided');
    return null;
  }
  
  return {
    item_category: category.name || '',
    item_category_id: category.id?.toString() || '',
    item_list_name: ANALYTICS_CONFIG.PARAMETERS.CATEGORY_LIST_NAME
  };
};

// Normalizzazione dati seller
export const normalizeSellerData = (seller) => {
  if (!seller || typeof seller !== 'object') {
    logger.warn('Invalid seller data provided');
    return null;
  }
  
  return {
    seller_id: seller.id?.toString() || '',
    seller_name: seller.name || seller.storeName || '',
    seller_category: seller.category || ''
  };
};

// Creazione struttura items per GA4
export const createItemsArray = (items = []) => {
  if (!Array.isArray(items)) {
    return [];
  }
  
  return items
    .map(item => {
      if (typeof item === 'object') {
        return normalizeProductData(item);
      }
      return null;
    })
    .filter(Boolean);
};

// Controllo disponibilità GA4
export const isGoogleAnalyticsAvailable = () => {
  return typeof window !== 'undefined' && 
         window.gtag && 
         typeof window.gtag === 'function' &&
         window.dataLayer;
};

// Timeout promise per operazioni asincrone
export const withTimeout = (promise, timeoutMs = ANALYTICS_CONFIG.DEBUG.TIMEOUT_MS) => {
  return Promise.race([
    promise,
    new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Operation timeout')), timeoutMs)
    )
  ]);
};

// Debounce per eventi frequenti
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Throttle per eventi frequenti
export const throttle = (func, limit) => {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}; 